/* Franco Leone — round close button for the header dropdown.
   The button lives outside the menu (so it can sit below the white panel on the blurred page).
   slot="overflow" tells header-menu.js the pointer is still "inside" the menu, so the menu stays open
   while the pointer moves from the panel onto the button. */
(function () {
  if (window.__flMegaFab) return;
  window.__flMegaFab = true;

  var mq = window.matchMedia('(min-width: 750px)');
  var wrap = document.createElement('div');
  var btn = document.createElement('button');
  var raf = null;
  var until = 0;

  wrap.id = 'fl-mega-fab';
  wrap.setAttribute('slot', 'overflow');
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Close menu');
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  wrap.appendChild(btn);

  function openInner() {
    var toggle = document.querySelector('#header-component .menu-list__disclosure[aria-expanded="true"]');
    var item = toggle && toggle.closest('.menu-list__list-item');
    return item ? item.querySelector('.menu-list__submenu-inner') : null;
  }

  function place() {
    var inner = openInner();
    if (!inner || !mq.matches) {
      wrap.classList.remove('is-visible');
      return;
    }
    var rect = inner.getBoundingClientRect();
    if (rect.height < 40) {
      wrap.classList.remove('is-visible');
      return;
    }
    wrap.style.top = rect.bottom - 2 + 'px';
    wrap.classList.add('is-visible');
  }

  function track() {
    place();
    raf = performance.now() < until ? requestAnimationFrame(track) : null;
  }

  function kick() {
    until = performance.now() + 700;
    if (!raf) raf = requestAnimationFrame(track);
  }

  function closeMenu() {
    var inner = openInner();
    var close = inner && inner.querySelector('[data-fl-close]');
    if (close) close.click();
  }

  btn.addEventListener('click', closeMenu);

  wrap.addEventListener('pointerleave', function (event) {
    var inner = openInner();
    if (!inner) return;
    var to = event.relatedTarget;
    var stillInside = to && to.closest && to.closest('.menu-list__list-item') === inner.closest('.menu-list__list-item');
    if (!stillInside) closeMenu();
  });

  new MutationObserver(kick).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded', 'hidden'],
  });
  window.addEventListener('scroll', place, { passive: true });
  window.addEventListener('resize', place);

  document.body.appendChild(wrap);
  document.documentElement.classList.add('fl-fab-ready');
})();

/* Franco Leone — left sidebar categories (Slip-On, Chappal, Monk …) open their collection page on click.
   Hover / keyboard focus still previews the category's panel (handled in blocks/_header-menu.liquid).
   On touch screens the first tap previews the panel, the next tap on the same category opens the collection.
   The collection URL is read from that panel's "VIEW ALL …" link, i.e. the menu link set in Content > Menus. */
(function () {
  if (window.__flMegaCategoryLinks) return;
  window.__flMegaCategoryLinks = true;

  function findTab(event) {
    var target = event.target;
    return target && target.closest ? target.closest('#header-component .fl-mega__category[data-fl-tab]') : null;
  }

  function categoryUrl(tab) {
    var root = tab.closest('[data-fl-mega]');
    var panel = root && root.querySelector('[data-fl-panel="' + tab.getAttribute('data-fl-tab') + '"]');
    var link = panel && panel.querySelector('.fl-mega__viewall');
    var href = link && link.getAttribute('href');
    return href && href !== '#' ? link.href : null;
  }

  // Capture phase: runs before the panel-switch handler, so "is-active" still reflects the state before this click.
  document.addEventListener(
    'click',
    function (event) {
      var tab = findTab(event);
      if (!tab || !tab.classList.contains('is-active')) return;
      var url = categoryUrl(tab);
      if (!url) return;
      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    },
    true
  );

  // Middle-click opens the collection in a new tab, like a normal link.
  document.addEventListener('auxclick', function (event) {
    if (event.button !== 1) return;
    var tab = findTab(event);
    var url = tab && categoryUrl(tab);
    if (!url) return;
    event.preventDefault();
    window.open(url, '_blank', 'noopener');
  });
})();
